(function () {
  'use strict';

  function initEbReviews(root) {
    if (!root || root.dataset.ebInit === 'true') return;
    root.dataset.ebInit = 'true';

    var track = root.querySelector('.eb-reviews__track');
    var prevBtn = root.querySelector('.eb-reviews__arrow--prev');
    var nextBtn = root.querySelector('.eb-reviews__arrow--next');
    if (!track) return;

    var AUTOPLAY_DELAY = 4500;
    var RESUME_DELAY = 3500;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var timer = null;
    var paused = false;
    var resumeTimeout = null;

    function cardStep() {
      var card = track.querySelector('.eb-reviews__card');
      if (!card) return track.clientWidth;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    function atStart() {
      return track.scrollLeft <= 2;
    }

    function scrollNext() {
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      }
    }

    function scrollPrev() {
      if (atStart()) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (prefersReducedMotion) return;
      timer = setInterval(function () {
        if (!paused) scrollNext();
      }, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function pauseThenResume() {
      paused = true;
      clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(function () {
        paused = false;
      }, RESUME_DELAY);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollNext();
        pauseThenResume();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollPrev();
        pauseThenResume();
      });
    }

    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('touchstart', function () { pauseThenResume(); }, { passive: true });
    track.addEventListener('pointerdown', function () { pauseThenResume(); });
    track.addEventListener('focusin', function () { paused = true; });
    track.addEventListener('focusout', function () { paused = false; });

    startAutoplay();

    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.target.contains(root)) stopAutoplay();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-eb-reviews]').forEach(initEbReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-eb-reviews]');
    if (root) initEbReviews(root);
  });
})();
